module.exports = {"id":"142756","name":"Patricio Toranzo","rating":"72","photo":"./data/images/photos/0/142756.png","club":{"name":"Parque Patricios","logo":"./data/images/clubs/ParquePatricios.png"},"positions":["MOC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PatricioToranzo0.json
// module id = 3377
// module chunks = 0